var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unit-value"},[_c('fm-input-number',{attrs:{"placehodler":"请输入分配值"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('Button',{staticStyle:{"margin-top":"10px"},attrs:{"type":"primary","loading":_vm.loading,"long":""},on:{"click":_vm.submit}},[_vm._v("确定")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }